import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Import Bootstrap an BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.config.productionTip = false;

require("./plugins/fontawesome");

new Vue({
    router,
    store,
    created() {
        // En caso de que la pagina sea actualizada retornar a la pagina principal
        // this.$router.push({ name: "Token" });
    },
    render: (h) => h(App),
}).$mount("#app");